<template>
    <div id="recordReceiptList">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Receipt List</div>
                    <div class="btn-groups text-right">
                        <!-- Button for Clear Cache -->
                        <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                        <a href="javascript:void(0)" class="btn btn-primary" v-on:click="exportCheck()">
                            <i class="fp-export"></i> Export
                        </a>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content receipt-list">
                        <data-table-filter-config :moduleName="'recordReceiptList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <div class="data-table bg-white overflow-hidden">
                          <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                          <section class="bg-white data-table">
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange" :moduleName="'recordReceiptList'" :position="'top'">
                                  </custom-pagination>

                                  <vue-good-table
                                      ref="listRecordReceipt"
                                      mode="remote"
                                      title="Record Receipt"
                                      @on-page-change="onPageChange"
                                      @on-selected-rows-change="selectionChanged"
                                      @on-column-filter="onColumnFilter"
                                      @on-per-page-change="onPerPageChange"
                                      @on-sort-change="onSortChange"
                                      :totalRows="totalRecords"
                                      :columns="userColumns"
                                      :rows="rows"
                                      :pagination-options="{
                                          enabled: false,
                                          position: 'both',
                                          perPage: perPage,
                                          perPageDropdown:dropDownPerPage,
                                          dropdownAllowAll: false,
                                      }"
                                      :select-options="{
                                      enabled: true,
                                      selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                      selectionInfoClass: 'custom-class',
                                      selectionText: 'rows selected',
                                      clearSelectionText: 'clear',
                                      }"
                                      :search-options="{
                                      enabled: false,
                                      }">

                                      <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                          <div :key="key">
                                              <div v-if="props.column.field == 'action'">
                                                  <template v-if="props.row.status != 'Closed'">
                                                      <router-link title="Edit Receipt" class="fp-edit" v-bind:to="{name: 'RecordReceiptEdit',params:{id:props.row.id}}"></router-link>
                                                  </template>
                                              </div>
                                              <div v-else-if="props.column.field == 'receipt_number'">
                                                  <template v-if="canViewPurchaseOrderReceipt">
                                                      <router-link title="View Receipt" class="color-blue" v-bind:to="{name: 'RecordReceiptView',params:{id:props.row.id}}">{{props.row.receipt_number}}</router-link>
                                                  </template>
                                                  <template v-else>
                                                      <span>{{props.row.receipt_number}}</span>
                                                  </template>
                                              </div>
                                              <div v-else-if="props.column.field == 'po_no'">
                                                  <template v-if="canViewPurchaseOrder">
                                                      <router-link title="View PO" class="color-blue" v-bind:to="{name: 'VendorPurchaseOrderView',params:{id:props.row.vendor_po_id},query:{fromUrl:fromUrl}}">{{props.row.po_no}}</router-link>
                                                  </template>
                                                  <template v-else>
                                                      <span>{{props.row.po_no}}</span>
                                                  </template>
                                              </div>
                                              <div v-else>
                                                  {{props.formattedRow[props.column.field]}}
                                              </div>
                                          </div>
                                      </template>

                                      <!-- <div slot="selected-row-actions">
                                          <button v-if="metric_type_value" id="deleteNewsBtn" v-on:click.prevent="metricTypeDelete" class="btn btn-success waves-effect">Delete</button>
                                      </div> -->
                                  </vue-good-table>
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange">
                                  </custom-pagination>
                          </section>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

    import EventBus from "./event-bus";
    import Vue from "vue";

    
    



    import {commonMixins} from '../mixins/commonMixins';
    import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "recordReceiptList",
        metaInfo: {
            // title will be injected into parent titleTemplate
            title: "Record Receipt List | " +process.env.COPYRIGHT_NAME
        },
        mixins:[commonMixins,dataTableMixins],
        props: {
            permitValue: {
                type: String,
                required: false,
                default:undefined
            },
            vendorPurchaseVal: {
                type: String,
                required: false,
                default:undefined
            }
        },
        data: () => ({

            firstLoad: 0,
            permissions: [],
            cantAccessPage: '',
            userColumns:[],
            columns: [
                {
                    label: 'Actions',
                    field: 'action',
                    sortable: false,
                },
                {
                    label: '#Receipt',
                    field: 'receipt_number',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "# Receipt", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: '#PO',
                    field: 'po_no',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "# PO", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Location',
                    field: 'location',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Location", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Vendor',
                    field: 'vendor',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Vendor", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Status',
                    field: 'status',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Status", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Pending','Good Received','Closed'],
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Receipt Date',
                    field: 'receipt_date',
                    fpFieldType:"date",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },

            ],
            rows: [],
            totalRecords: 0,
            asset_value: false,
            loading:false,
            permit_value:false,
            assetId:"",
            selectedFile:"",
            canViewPurchaseOrder:false,
            viewPageParam:"",
            action:'list',
            pageKey:"_record_receipt_list",
            from:'vendor',
            canViewPurchaseOrderReceipt:false,
            fromUrl:'',
            batchProcess:0,
            batchNum:"",
        }),
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_purchase_order_receipt') {
                            self.cantAccessPage = true;
                        }

                        if (permissions[i].name == 'view_purchase_order') {
                            self.canViewPurchaseOrder = true;
                        }
                        if (permissions[i].name == 'view_purchase_order_receipt') {
                            self.canViewPurchaseOrderReceipt=true;
                        }
                    }
                }

            }
        },
        created: function() {

        },
        mounted: function() {

            var self = this;

            self.getPermissions();
            self.fromUrl = btoa(window.location.pathname);

            //not initialize to get element
            // setTimeout(function() {
            //     self.loadList();
            // }, 1000);

        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listRecordReceipt.unselectAllInternal();
            },
        selectionChanged(param) {
            var self = this;
            self.serverParams.selectedAll = false;
            if(param.selectedRows.length == 100) {
              EventBus.$emit('clear-selection', false);
            } else {
              EventBus.$emit('clear-all-flags', false);
            }
            return;
        },
        loadList() {

            var self = this;
            var selectedRows = [];

            var data = this.$refs['listRecordReceipt'].selectedRows;

            for (var i = 0; i < data.length; i++) {
                selectedRows.push(self.$refs['listRecordReceipt'].selectedRows[i].id)
            }

            self.loading = true;
            var fields = {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: self.serverParams.columnFilters,
                sort: self.serverParams.sort,
                all:self.serverParams.selectedAll,
                selectedRows:selectedRows,
                action:self.action,
                from:self.from
            };
            self.firstLoad = 1;
            $.ajax({
                url: process.env.ROOT_API + "/record-receipt/list",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {
                        if ( self.action == "delete" ) {

                            self.action = "list";
                            $("#deletePurchaseOrderTypeBtn").val("Delete");

                            self.$refs.filterComponent.clearSelectAll();
                            self.loadList();
                            EventBus.$emit('clear-all-flags', false);   //hide alert of selection

                        }else if ( self.action == "export" ||  self.action == "export_queue") {
                            if ( data.code == "201" ) {
                                alert(data.message);
                            } else {
                                if ( self.action == "export" ) {
                                    self.excel = data.content.web;
                                    var save = document.createElement("a");
                                    save.href = self.excel;
                                    save.download = data.content.web;
                                    save.target = "_blank";

                                    document.body.appendChild(save);
                                    save.click();
                                    document.body.removeChild(save);

                                } else {

                                    self.batchProcess = 1;
                                    self.batchNum = data.content;
                                }
                            }
                            self.action = "list";
                            // self.loadList();
                        }else{
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                            EventBus.$emit("purchaseOrderCount", data.content.pocount);
                            EventBus.$emit("customerpurchaseOrderCount", data.content.custpocount);
                            self.filteredFlag = false;
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if ( self.action == "delete" ) {
                        self.generateStatusCodeMessage(jqXHR, true, 'vendor-po-delete')
                    }else{
                        self.generateStatusCodeMessage(jqXHR, false, 'vendor-po-list')
                    }
                }
            });
        },
        PurchaseOrderDelete() {
            if (confirm('Are you sure that you want to delete this Receipt? ')) {

                this.action = "delete";
                $("#deletePurchaseOrderTypeBtn").val("Deleting ...");

                this.loadList();

            }
        },
        exportCheck: function() {
            var self = this;
            var count = 0;
            var actionFlag = "";
            var data = this.$refs['listRecordReceipt'].selectedRows;
            count = data.length;

            if(this.serverParams.selectedAll == true){
                actionFlag = "";
            }else if(count != 0 && count <= 100){
                actionFlag = "export";
            }

            this.exportReports(actionFlag);
        },
    }
};
</script>



// WEBPACK FOOTER //
// src/components/RecordReceiptList.vue